import { APP_INITIALIZER, EnvironmentProviders, Provider, inject } from "@angular/core";
import { provideIcons } from "@core/icons/icons.provider";
import { TranslocoHttpLoader } from "@core/transloco/transloco.http-loader";
import { TranslocoService, provideTransloco } from "@ngneat/transloco";
import { firstValueFrom } from "rxjs";

export const providerUploadTargx = (): Array<Provider | EnvironmentProviders> => {

  const providers: Array<Provider | EnvironmentProviders> = [


    // Transloco Config
    provideTransloco({
      config: {
        availableLangs: [
          {
            id: 'en',
            label: 'English',
          },
          {
            id: 'pt',
            label: 'Português',
          },
        ],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: true,
      },
      loader: TranslocoHttpLoader,
    }),
    {
      // Preload the default language before the app starts to prevent empty/jumping content
      provide: APP_INITIALIZER,
      useFactory: () => {
        const translocoService = inject(TranslocoService);
        const defaultLang = translocoService.getDefaultLang();
        translocoService.setActiveLang(defaultLang);

        return () => firstValueFrom(translocoService.load(defaultLang));
      },
      multi: true,
    },


    // Icons
    provideIcons(),

  ];

  return providers;
};
